import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({ baseURL: `${BACKEND_URL}/api` });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("wynn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;
